enum AkamaiImageQualityEnum {
	low = 'low',
	medium = 'medium',
	high = 'high'
}

export default AkamaiImageQualityEnum;
